
import {
  MagicItemKeyword,
  Item,
  Limitation,
  Spell,
  Recipe,
} from "@dndModels";
import { AttackType, ItemType } from "@dndModels/Types";


export class PseudoItem {
  base_item: Item | null = null;
  magic_item_keywords: MagicItemKeyword[] = [];
  potion_level = -1;
  _description = "";
  extra = "";
  extra_spell: Spell | null = null;
  selected_rarity = -1;

  constructor(obj?: any, extra = "", extra_spell: Spell | null = null) {
    if (obj) {
      if (obj instanceof Item) {
        this.base_item = obj;
        this.selected_rarity = obj.min_rarity;
      } else if (obj instanceof PseudoItem) {
        this.base_item = obj.base_item;
        this.magic_item_keywords = [...obj.magic_item_keywords];
        this.selected_rarity = obj.selected_rarity;
      } else {
        this.selected_rarity = obj.selected_rarity !== undefined ? obj.selected_rarity : -1;
      }
      this.extra = extra;
      this.extra_spell = extra_spell;
    }
  }

  add_keyword(keyword: MagicItemKeyword, extra = "", extra_spell: Spell | null = null) {
    this.magic_item_keywords.push(keyword);
    this.extra = extra;
    this.extra_spell = extra_spell;
  }

  get the_base_item(): Item | null {
    if (this.base_item) {
      return this.base_item;
    }
    return null;
  }

  get item_type(): ItemType {
    if (this.base_item) {
      return this.base_item.item_type;
    }
    return "Other";
  }

  get the_effect_types(): string[] {
    let effect_types: string[] = [];
    if (this.base_item) {
      effect_types = this.base_item.the_effect_types;
    }
    for (const mik of this.magic_item_keywords) {
      effect_types = [...effect_types,...mik.the_effect_types];
    }
    if (this.extra_spell) {
      effect_types = [...effect_types,...this.extra_spell.effect_types];
    }

    return effect_types;
  }

  get the_attack_types(): AttackType[] {
    let attack_types: AttackType[] = [];
    if (this.base_item) {
      attack_types = this.base_item.the_attack_types;
    }
    for (const mik of this.magic_item_keywords) {
      attack_types = [...attack_types,...mik.the_attack_types];
    }
    if (this.extra_spell) {
      attack_types = [...attack_types,...this.extra_spell.attack_types];
    }

    return attack_types;
  }

  get the_utility_details(): string[] {
    let effect_types: string[] = [];
    if (this.base_item) {
      effect_types = this.base_item.the_utility_details;
    }
    for (const mik of this.magic_item_keywords) {
      effect_types = [...effect_types,...mik.the_utility_details];
    }
    if (this.extra_spell) {
      effect_types = [...effect_types,...this.extra_spell.the_utility_details];
    }

    return effect_types;
  }

  get use_selected_rarity(): number {
    if (this.selected_rarity === -1 && this.base_item) {
      if (this.base_item.min_rarity !== this.base_item.max_rarity) {
        return this.base_item.min_rarity;
      }
      if (this.varying_mik) {
        return this.varying_mik.min_rarity;
      }
    }
    return this.selected_rarity;
  }

  get name(): string {
    let name = "";
    const selected_rarity = this.use_selected_rarity;
    if (this.base_item) {
      name = this.base_item.useNameForRarity({ selected_rarity, extra: this.extra, extra_spell: this.extra_spell });
      // if (this.extra !== "") {
      //   if (this.extra_spell) {
      //     name = name.replace("{extra.name}", this.extra_spell.name);
      //   } else {
      //     name = name.replace("{extra}", this.extra);
      //   }
      // }
    }
    if (this.varying_mik) {
      const name_rarities = Object.keys(this.varying_mik.rarity_names);
      let name2 = "";
      if (name_rarities.length === 0) {
        name2 = `${this.varying_mik.name_formula}`;
        name2 = name2.replace("{selected_rarity}", `${selected_rarity}`);
      } else if (name_rarities.includes(`${selected_rarity}`)) {
        name2 = this.varying_mik.rarity_names[selected_rarity];
      } 
      name = name2.replace("{base_item.name}", name);
    }
    for (const keyword of this.flat_miks) {
      // Adamantine {base_item.name}
      const name2 = `${keyword.name_formula}`;
      name = name2.replace("{base_item.name}", name);
    }
    if (name.includes("{extra") && this.extra !== "") {
      if (this.extra_spell) {
        name = name.replace("{extra.name}", this.extra_spell.name);
      } else {
        name = name.replace("{extra}", this.extra);
      }
    }

    if (this.potion_level > 0) {
      name += ` ${this.potion_level}`;
    }

    return name;
  }

  get description(): string {
    let description = "";
    if (this.base_item) {
      description = this.base_item.description;
    }
    for (const mik of this.magic_item_keywords) {
      if (description.length > 0) {
        description += "\n";
      }
      description += mik.description;
      if (this.extra !== "") {
        if (this.extra_spell) {
          while (description.includes("{extra.name}")) {
            description = description.replace("{extra.name}", this.extra_spell.name);
          }
          while (description.includes("{extra.description}")) {
            description = description.replace("{extra.description}", this.extra_spell.description);
          }
        } else {
          while (description.includes("{extra}")) {
            description = description.replace("{extra}", this.extra);
          }
        }
      }
    }

    return description;
  }

  get base_item_extra(): boolean {
    return this.base_item !== null && this.base_item.extra_base_type !== "" && this.base_item.extra_base_type !== "None";
  }

  get id(): string {
    let id = "";
    if (this.base_item) {
      id = "B:" + this.base_item._id;
    }
    for (const keyword of this.magic_item_keywords) {
      if (id !== "") {
        id += ",";
      }
      id += "K:" + keyword._id;
    }
    if (this.potion_level > 0) {
      id += ",L:" + this.potion_level;
    }
    
    if (this.base_item_extra) {
      if (this.extra !== "") {
        id += ",BIE:" + this.extra;
      }
    } else if (this.extra !== "") {
      id += ",E:" + this.extra;
    }
    if (this.use_selected_rarity > -1) {
      id += `,R:${this.use_selected_rarity}`;
    }

    return id;
  }

  get _id() {
    return this.id;
  }

  get varying_mik(): MagicItemKeyword | undefined {
    return this.magic_item_keywords.find(o => o.min_rarity !== o.max_rarity);
  }

  get flat_miks(): MagicItemKeyword[] {
    return this.magic_item_keywords.filter(o => o.min_rarity === o.max_rarity);
  } 

  get rarity(): number {
    let rarity = 0;
    if (this.base_item) { 
      // Can only have one part from base_item and miks that has varying rarities
      if (this.base_item.min_rarity !== this.base_item.max_rarity) { 
        // base_item has varying rarities
        rarity += this.use_selected_rarity;
      } else {
        rarity += this.base_item.min_rarity;
        if (this.varying_mik) {
          rarity += this.use_selected_rarity;
        }
      }
      for (const keyword of this.flat_miks) {
        rarity += keyword.min_rarity;
      }
    }
    if (this.potion_level > 7) {
      rarity += 3; // Very-Rare
    } else if (this.potion_level > 5) {
      rarity += 2; // Rare
    } else if (this.potion_level > 3) {
      rarity += 1; // Uncommon
    }
    return rarity;
  }

  get override_weapon_damage_type(): string {
    const override_weapon_damage_types = this.magic_item_keywords.map(o => o.override_weapon_damage_type);
    return override_weapon_damage_types.length > 0 ? override_weapon_damage_types[0] : "";
  }

  get magic_item_keyword_ids() {
    return this.magic_item_keywords.map(o => o._id);
  }

  get weight(): number {
    if (this.base_item) {
      return this.base_item.weight;
    }
    return 0;
  }

  // get color(): string {
  //   let color = "inherit"; // Common
  //   switch (this.rarity) {
  //     case 1: color = "green"; break; // Uncommon
  //     case 2: color = "blue"; break; // Rare
  //     case 3: color = "purple"; break; // Very-Rare
  //     case 4: color = "orange"; break; // Legendary
  //     case 5: color = "brown"; break; // Artifact
  //   }
  //   return color;
  // }

  get attunement(): boolean {
    if ((this.base_item && this.base_item.attunement) || this.magic_item_keywords.filter(o => o.attunement).length > 0) {
      return true;
    }
    return false;
  }

  get limitations(): Limitation[] {
    let limitations: Limitation[] = [];
    if (this.base_item) {
      limitations = [...limitations,...this.base_item.limitations];
    }
    this.magic_item_keywords.forEach(keyword => {
      limitations = [...limitations,...keyword.limitations];
    });
    return limitations;
  }

  get charges(): number {
    if (this.base_item && this.base_item.charges > 0) {
      return this.base_item.charges;
    }
    for (let i = 0; i < this.magic_item_keywords.length; ++i) {
      const keyword = this.magic_item_keywords[i];
      if (keyword.charges > 0) {
        return keyword.charges;
      }
    }
    return 0;
  }

  get keyword_ids(): string[] {
    return this.magic_item_keywords.map(o => o._id);
  }

  get monster(): boolean {
    if (this.base_item && this.base_item.monster) {
      return true;
    }
    for (const mik of this.magic_item_keywords) {
      if (mik.monster) {
        return true;
      }
    }
    return false;
  }

  get cost(): number {
    if (this.base_item && this.magic_item_keywords.length === 0) {
      return this.base_item.cost;
    } else {
      return 0;
    }
  }

  get recipes(): Recipe[] {
    let recipes: Recipe[] = [];
    if (this.base_item) {
      recipes = this.base_item.recipes.map(o => o.clone());
    }
    for (const mik of this.magic_item_keywords) {
      const new_recipes: Recipe[] = [];
      if (recipes.length === 0) {
        recipes = mik.recipes.map(o => o.clone());
      } else {
        for (const recipe of recipes) {
          for (const recipe2 of mik.recipes) {
            const new_recipe = recipe.clone();
            new_recipe.merge(recipe2);
            new_recipes.push(new_recipe);
          }
        }
        recipes = new_recipes;
      }
    }
    let extra_details = "";
    if (this.magic_item_keywords.length > 1) {
      extra_details = "Adding Multiple Magic Item Keywords to an item isn't allowed in standard D&D.\n  If your DM allows it, crafting them may have extra requirements.\n  By default we not only combine the components, but we also total the CR required for the recipe.";
    } else if (this.base_item && this.base_item.magical && this.magic_item_keywords.length > 0) {
      extra_details = "Adding Magic Item Keywords to Magic Items isn't allowed in standard D&D.\n  If your DM allows it, crafting them may have extra requirements.\n  By default we not only combine the components, but we also total the CR required for the recipe.";
    }
    for (const recipe of recipes) {
      recipe.item_id = this.id;
      if (extra_details.length > 0 && !recipe.extra_details.includes(extra_details)) {
        recipe.extra_details += extra_details;
      }
    }
    return recipes;
  }

  copy(copyMe: PseudoItem) {
    this.base_item = copyMe.base_item;
    this.magic_item_keywords = [...copyMe.magic_item_keywords];
    this.potion_level = copyMe.potion_level;
    this._description = copyMe._description;
    this.extra = copyMe.extra;
    this.extra_spell = copyMe.extra_spell;
  }

  clone() {
    const clone = new PseudoItem();
    clone.copy(this);
    return clone;
  }
}